<template>
    <div
        v-if="gameCompleted && totalPlayers > 1 && !isIamNewPlayer"
        :class="['finalGameStatus', isIamAdmin ? 'admin' : '']"
    >
        <span v-if="didIwonTheGame" class="winner">WON</span>
        <span v-else class="loser">LOST</span>
        <div>
            <b-alert v-if="!didIwonTheGame" show variant="info">
                {{
                getWonStatusText
                }}
            </b-alert>
            <b-alert v-else-if="wonPlayersIds.length > 1" show variant="info">
                {{
                getWonStatusText
                }}
            </b-alert>
        </div>
    </div>
</template>
<script>
import store from "@/store";
export default {
    computed: {
        getWonStatusText: () => store.getters.getWonStatusText,
        totalPlayers: () => store.getters.totalPlayers,
        wonPlayersIds: () => store.getters.wonPlayersIds,
        playersCount: () => store.getters.playersCount,
        didIwonTheGame: () => store.getters.didIwonTheGame,
        gameCompleted: () => store.getters.gameCompleted,
        isIamAdmin: () => store.getters.isIamAdmin,
        isIamNewPlayer: () => store.getters.isIamNewPlayer
    }
};
</script>
